import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { getSubjects } from "../lib/requestFunctions";


export function useSubjects(selectedClass: string | undefined) {
    const [selectedSubject, setSelectedSubject] = useState<
        string | undefined
    >(undefined);

    // Then get the user's projects
    const {
        status: subjectStatus,
        fetchStatus: subjectFetchStatus,
        data: subjects,
    } = useQuery({
        queryKey: ["subjects", selectedClass],
        queryFn: () =>
            getSubjects(
                selectedClass
                    ? Array.isArray(selectedClass)
                        ? selectedClass
                        : [selectedClass]
                    : [],
            ),
        // The query will not execute until the userId exists
        enabled: !!selectedClass,
    });

    useEffect(() => {
        setSelectedSubject(undefined);
    }, [selectedClass]);

    const subjectsData = subjects?.data.map((subj) => ({
        key: subj.id,
        text: subj.name,
    })) ?? [];

    return {
        selectedSubject,
        setSelectedSubject,
        subjectsData,
        subjectsLoading: subjectStatus === 'pending' && subjectFetchStatus === 'fetching',
        subjectsError: subjectStatus === 'error',
    }
}